import React, { useEffect, useState } from "react";
import { vehicleGroupService } from "../../../../Services/vehicle.group.service";
import { configsService } from "../../../../Services/configs.service";
import {
  buildReportConfigFromApi,
  ensureHighSpeedDefaults,
} from "../../../../components/ReportConfig/vehicleGroupReportConfig.utils";

function normalizeFormat(value, fallback = "P") {
  if (!value) return fallback;
  const map = { pdf: "P", p: "P", excel: "E", e: "E", kmz: "K", k: "K" };
  return map[String(value).toLowerCase()] ?? fallback;
}

export default function CopyGroupConfig({ currentGroupId, onCopy, listCollor = [] }) {
  const [groups, setGroups] = useState([]);
  const [selectedSourceId, setSelectedSourceId] = useState("");
  const [isCopying, setIsCopying] = useState(false);
  const [copyError, setCopyError] = useState("");

  useEffect(() => {
    vehicleGroupService.fetchGroups().then((res) => {
      if (Array.isArray(res)) {
        // Exclui o grupo atual da lista
        setGroups(res.filter((g) => String(g.vehicleGroupId) !== String(currentGroupId)));
      }
    });
  }, [currentGroupId]);

  const handleCopy = async () => {
    if (!selectedSourceId) return;
    setIsCopying(true);
    setCopyError("");

    try {
      const reportsConfig = await configsService.fetchGroupReportsConfiguration(
        selectedSourceId
      );

      if (!reportsConfig || !Array.isArray(reportsConfig) || reportsConfig.length === 0) {
        setCopyError("Não foi possível carregar a configuração do grupo selecionado.");
        return;
      }

      const groupData = reportsConfig[0];
      const colorId = groupData.colorId || "";
      const colorObj = listCollor.find((c) => String(c.colorId) === String(colorId));
      const selectedColor = colorObj?.hex || "";


      const kmzFlag     = groupData.emailKmzCheckFlag       === "S";
      const fenceFlag   = groupData.emailFenceCheckFlag     === "S";
      const visitFlag   = groupData.emailVisitCheckFlag     === "S";
      const riskAreaFlag= groupData.emailRiskAreaCheckFlag  === "S";
      const strechesFlag= groupData.emailSegmentCheckFlag   === "S";


      const mappedReportConfig = ensureHighSpeedDefaults(
        buildReportConfigFromApi(groupData)
      );
      const relatorios = {
        kmz: kmzFlag,
        movimentacao: groupData.emailMovementCheckFlag === "S",
        pontoDeVista: visitFlag,
        areaDeRisco: riskAreaFlag,
        cercaEletronica: fenceFlag,
        ...mappedReportConfig.reduce((acc, cfg) => {
          acc[cfg.id] = !!cfg.ativo;
          return acc;
        }, {}),
      };


      const archives = {
        archiveKmz:            normalizeFormat(groupData.emailKmzAttachmentFormat, "K"),
        archiveMovimentacao:   normalizeFormat(groupData.emailMovementCheckAttachmentFormat, "P"),
        archivePontoDeVista:   "P",
        archiveAreaDeRisco:    "P",
        archiveCercaEletronica:"P",
      };


      const movementForm = {
        weekdays: {
          flag:  groupData.movementCheckMonToFriFlag  === "S",
          start: groupData.movementCheckMonToFriStart?.substring(0, 5) || "08:00",
          end:   groupData.movementCheckMonToFriEnd?.substring(0, 5)   || "18:00",
        },
        saturday: {
          flag:  groupData.movementCheckSatFlag  === "S",
          start: groupData.movementCheckSatStart?.substring(0, 5) || "08:00",
          end:   groupData.movementCheckSatEnd?.substring(0, 5)   || "18:00",
        },
        sunday: {
          flag:  groupData.movementCheckSunFlag  === "S",
          start: groupData.movementCheckSunStart?.substring(0, 5) || "08:00",
          end:   groupData.movementCheckSunEnd?.substring(0, 5)   || "18:00",
        },
        emailNotificationFlag: groupData.emailMovementCheckFlag === "S",
        attachmentFormat: normalizeFormat(groupData.emailMovementCheckAttachmentFormat, "P"),
      };


      const speedForm = {
        urban:   { flag: groupData.urbanSpeedCheckFlag === "S", value: groupData.urbanSpeedCheckValue?.toString() || "30" },
        highway: { flag: groupData.roadSpeedCheckFlag  === "S", value: groupData.roadSpeedCheckValue?.toString()  || "30" },
        emailNotificationFlag: groupData.emailSpeedCheckFlag === "S",
        attachmentFormat: normalizeFormat(groupData.emailSpeedCheckAttachmentFormat, "P"),
      };

      onCopy({
        colorId,
        selectedColor,
        kmzFlag,
        fenceFlag,
        visitFlag,
        riskAreaFlag,
        strechesFlag,
        relatorios,
        archives,
        movementForm,
        speedForm,
        reportConfigPayload: mappedReportConfig,
      });
    } catch (err) {
      console.error("Erro ao copiar configuração do grupo:", err);
      setCopyError("Erro ao copiar. Tente novamente.");
    } finally {
      setIsCopying(false);
    }
  };

  return (
    <div
      className="card col-md-12 p-3 mb-3"
      style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: 12, flexWrap: "wrap" }}
    >
      <span style={{ fontWeight: 500, color: "var(--text-primary)", whiteSpace: "nowrap" }}>
        Copiar configuração do grupo
      </span>

      <select
        className="form-select"
        style={{ maxWidth: 280 }}
        value={selectedSourceId}
        onChange={(e) => {
          setSelectedSourceId(e.target.value);
          setCopyError("");
        }}
      >
        <option value="">Lista de Grupos</option>
        {groups.map((g) => (
          <option key={g.vehicleGroupId} value={g.vehicleGroupId}>
            {g.vehicleGroupName}
          </option>
        ))}
      </select>

      <button
        className="btn btn-success"
        type="button"
        disabled={!selectedSourceId || isCopying}
        onClick={handleCopy}
        style={{ whiteSpace: "nowrap" }}
      >
        {isCopying ? (
          <>
            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
            Copiando...
          </>
        ) : (
          "Copiar"
        )}
      </button>

      {copyError && (
        <span style={{ color: "red", fontSize: 10 }}>{copyError}</span>
      )}
    </div>
  );
}
